import Id from "../assests/id.png"
import AdmissionDate from "../assests/admission_date.png";
import SeparationDate from "../assests/separation_date.png";
import SeparationMode from "../assests/separation_mode.png";
import AdditionalDiagnosis from "../assests/additional_diagnosis.png";
import PrincipalDiagnosis from "../assests/principal_diagnosis.png";
import DateofBirth from "../assests/date_of_birth.png";
import Weight from "../assests/weight.png"
import Gender from "../assests/gender.png"
import Interventions from "../assests/Interventions.png"
import InfoIcon from "../assests/info.png";

export const configData = [
  {
    label: "ID",
    name: "id",
    icon: Id,
    info_icon: InfoIcon,
    type: "number",
    info: "This is Id Field"
  },
  {
    label: "Admission Date",
    name: "adm_date",
    icon: AdmissionDate,
    info_icon: InfoIcon,
    type: "date",
    info: "This is Admission Date Field"

  },
  {
    label: "Separation Date",
    name: "sep_date",
    icon: SeparationDate,
    info_icon: InfoIcon,
    type: "date",
    info: "This is Separation Date Field"
  },
  {
    label: "Separation Mode",
    name: "sep_mode",
    icon: SeparationMode,
    info_icon: InfoIcon,
    type: "number",
    info: "This is Separation Mode Field"
  },
  {
    label: "Date of Birth",
    name: "bir_date",
    icon: DateofBirth,
    info_icon: InfoIcon,
    type: "date",
    info: "This is Date of Birth Field"
  }, {
    label: "Weight",
    name: "adm_wt",
    icon: Weight,
    info_icon: InfoIcon,
    type: "number",
    info: "This is Weight Field"
  },
  {
    label: "Age Years",
    name: "ageyears",
    icon: DateofBirth,
    info_icon: InfoIcon,
    type: "number",
    info: "This is Age Years Field"
  },
  {
    label: "Age Days",
    name: "agedays",
    icon: SeparationDate,
    info_icon: InfoIcon,
    type: "number",
    info: "This is Age Days Field"
  },
  {
    label: "Gender",
    name: "sex",
    icon: Gender,
    info_icon: InfoIcon,
    type: "text",
    // options: [
    //   { label: "MALE", value: "1" },
    //   { label: "FEMALE", value: "2" },
    //   { label: "TRANSGENDER", value: "3" },
    //   { label: "OTHER", value: "9" },
    // ],
    info: "This is Gender Field"
  }, {
    label: "HMV",
    name: "hmv",
    icon: AdmissionDate,
    info_icon: InfoIcon,
    type: "number",
    info: "This is HMV Field"
  },
  {
    label: "Principal Diagnosis",
    name: "x12ddx1",
    icon: PrincipalDiagnosis,
    info_icon: InfoIcon,
    type: "text",
    info: "This is Principal Diagnosis Field"
  },
  {
    label: "Additional Diagnosis",
    name: ["x12ddx2", "x12ddx3", "x12ddx4", "x12ddx5", "x12ddx6", "x12ddx7", "x12ddx8", "x12ddx9", "x12ddx10", "x12ddx11", "x12ddx12", "x12ddx13", "x12ddx14", "x12ddx15", "x12ddx16", "x12ddx17", "x12ddx18", "x12ddx19", "x12ddx20", "x12ddx21", "x12ddx22", "x12ddx23", "x12ddx24", "x12ddx25", "x12ddx26", "x12ddx27", "x12ddx28", "x12ddx29", "x12ddx30"],
    icon: AdditionalDiagnosis,
    info_icon: InfoIcon,
    type: "text",
    info: "This is Additional Diagnosis Field"
  },
  {
    label: "Interventions",
    name: ["x12srg1", "x12srg2", "x12srg3", "x12srg4", "x12srg5", "x12srg6", "x12srg7", "x12srg8", "x12srg9", "x12srg10", "x12srg11", "x12srg12", "x12srg13", "x12srg14", "x12srg15", "x12srg16", "x12srg17", "x12srg18", "x12srg19", "x12srg20", "x12srg21", "x12srg22", "x12srg23", "x12srg24", "x12srg25", "x12srg26", "x12srg27", "x12srg28", "x12srg29", "x12srg30"],
    icon: Interventions,
    info_icon: InfoIcon,
    type: "text",
    info: "This is Interventions Field"
  },
  {
    label: "LOS",
    name: "los",
    icon: SeparationMode,
    info_icon: InfoIcon,
    type: "number",
    info: "This is LOS Field"
  }, {
    label: "Leave Days",
    name: "leavedays",
    icon: DateofBirth,
    info_icon: InfoIcon,
    type: "number",
    info: "This is Leave Days Field"
  },
  {
    label: "SDF",
    name: "sdf",
    icon: PrincipalDiagnosis,
    info_icon: InfoIcon,
    type: "number",
    info: "This is SDF Field"
  },



];